import * as yup from 'yup';

export const emailSchema = yup.string().trim().email('Niepoprawny adres e-mail').required('Adres e-mail jest wymagany');
export const agreementSchema = yup.bool().oneOf([true], 'Zgoda jest wymagana');
